import React from 'react';
import Page from 'components/Page';
import ResearchUploader from './ResearchUploader';
import { ReactComponent as ResearchIcon } from 'assets/icons/icon-book-closed.svg';
import { useHasura } from 'context/ApiState';
import Button from 'components/Button';

const AdminManageResearch = () => {
  const { research, removeResearch } = useHasura();

  const deleteButtonHandler = async (
    research_id: number,
    upload_id: string,
  ) => {
    await removeResearch({ research_id, upload_id });
    console.log('done');
  };

  return (
    <Page
      icon={
        <ResearchIcon className="inline w-10 h-10 mr-2 -mb-1 text-gray-500" />
      }
      title="Manage Research Documents"
    >
      <ResearchUploader />
      <p>
        N.B. Uploads are currently only visible to the 'Demo Company'
        Organisation.
      </p>
      <ul>
        {research?.map(
          ({
            id: research_id,
            research_title,
            research_date,
            upload: { id: upload_id, public_url },
          }) => (
            <li key={research_id}>
              [{research_id}] {research_title} ({research_date})
              {public_url && ' - ' + public_url}, visible to {'all'}{' '}
              organisations
              <Button
                className="btn btn-small btn-white-danger"
                onClick={() => deleteButtonHandler(research_id, upload_id)}
              >
                delete
              </Button>
            </li>
          ),
        )}
      </ul>
    </Page>
  );
};

export default AdminManageResearch;
